import React from "react";
import Classes from "./Classes";
import Styles from "./Styles";
import ConditionalOutput from "./ConditionalOutput";
import TodoList from "./Todo/TodoList";
import ReduxExamples from "./ReduxExamples/components";

const PracticeA7 = () => {
  return(
      <>
        <h1>Practice</h1>
        <ReduxExamples/>
          <TodoList/>
          <ConditionalOutput/>
          <Styles/>
          <Classes/>
      </>
  )
};

export default PracticeA7;
